import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const DropdownHeader = styled.div`
  border: 1px solid #ccc;
  padding: 10px 20px;
  background: white;
  border-radius: 8px;

  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background: white;
  z-index: 10;
  padding: 0;
  margin: 0;
  list-style: none;
`;

const DropdownItem = styled.li`
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
`;

const FlagImage = styled.img`
  width: 20px;
  height: 15px;
  object-fit: cover;
`;

const CountryDropdown = ({ setSelectedCountry, setSelectedCountryCode }) => {
  const [countries, setCountries] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(
          "https://restcountries.com/v3.1/all?fields=name,cca2,flags"
        );
        const data = await response.json();
        const countryOptions = data.map((country) => ({
          name: country.name.common,
          code: country.cca2,
          flag: country.flags.png,
        }));
        countryOptions.sort((a, b) => a.name.localeCompare(b.name));
        setCountries(countryOptions);
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (country) => {
    setSelected(country);
    setSelectedCountry(country.name);
    setSelectedCountryCode(country.code);
    setIsOpen(false);
  };

  return (
    <DropdownWrapper ref={wrapperRef}>
      <DropdownHeader onClick={() => setIsOpen(!isOpen)}>
        {selected ? (
          <>
            <FlagImage src={selected.flag} alt={selected.name} />
            {selected.name}
          </>
        ) : (
          "-- Please select a country --"
        )}
      </DropdownHeader>
      {isOpen && (
        <DropdownList>
          {countries.map((country) => (
            <DropdownItem
              key={country.code}
              onClick={() => handleSelect(country)}
            >
              <FlagImage src={country.flag} alt={country.name} />
              {country.name}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </DropdownWrapper>
  );
};

export default CountryDropdown;
